<template>
  <v-card-component :title="cardTitle" :icon="cardIcon">
    <v-row>
      <v-col cols="12" v-if="formType === 'studEdit'">
        <span class="body-2 font-weight-medium">Student Full Name</span>
        <span class="error--text ml-1">*</span>
        <v-text-field
          type="text"
          v-model.trim="value.studentName"
          required
          :readonly="isReadonly"
          :disabled="isDisabled"
          placeholder="Student Full Name"
          class="my-0 py-1"
          single-line
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" v-else>
        <v-row>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">Student First Name</span>
            <span class="error--text ml-1">*</span>
            <v-text-field
              type="text"
              placeholder="Student First Name"
              v-model.trim="value.studentFirstName"
              required
              :readonly="isReadonly"
              :disabled="isDisabled"
              class="my-0 py-1"
              single-line
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium"> Middle Name</span>
            <v-text-field
              type="text"
              placeholder="Student Middle Name"
              v-model.trim="value.studentMiddleName"
              :readonly="isReadonly"
              :disabled="isDisabled"
              class="my-0 py-1"
              single-line
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">Last Name</span>
            <v-text-field
              type="text"
              placeholder="Student Last Name"
              class="my-0 py-1"
              single-line
              v-model.trim="value.studentLastName"
              :readonly="isReadonly"
              :disabled="isDisabled"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"
          >Date of Birth
          <span
            class="error--text ml-1"
            v-if="isEnquiry === false || subType === 'admission_offon'"
            >*</span
          ></span
        >
        <custom-date-picker
          v-model="value.dateOfBirth"
          :maxToDate="maxToDate"
          :disabled="isApplication"
          :required="isEnquiry === false ? true : false"
        />
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"
          >Gender
          <span
            class="error--text"
            v-if="isEnquiry === false || subType === 'admission_offon'"
            >*</span
          ></span
        >
        <v-radio-group
          @change="genderChangeHandler()"
          v-model="value.gender"
          row
          v-validate="'required'"
        >
          <v-radio
            label="Boy"
            name="gender"
            value="Male"
            class="mr-7"
            :readonly="isReadonly"
            :disabled="isDisabled"
          >
          </v-radio>
          <v-radio
            label="Girl"
            name="gender"
            value="Female"
            :readonly="isReadonly"
            :disabled="isDisabled"
          >
          </v-radio>
        </v-radio-group>
      </v-col>
      <v-col v-if="value.gender && isUniformSelection" cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"
          >Select Uniform Size
          <span
            class="error--text"
            v-if="isEnquiry === false || subType === 'admission_offon'"
            >*</span
          ></span
        >
        <br />
        <v-btn
          @click="selectAllModal = true"
          color="success"
          class="px-2 ml-1 ma-1"
          min-width="0"
          small
        >
          <v-icon small> mdi-pencil </v-icon>
          <span class="ml-1">
            {{
              value.studentAppreals && value.studentAppreals.length > 0
                ? 'Edit Size'
                : 'Select Size'
            }}
          </span>
        </v-btn>
        <!-- <a @click="selectAllModal = true">{{ uniformsData.length > 0 ? 'Edit Size' : 'Select Size' }}</a> -->
      </v-col>
      <v-col v-if="value.gender" cols="12" sm="12">
        <v-simple-table v-if="uniformsData.length > 0">
          <template v-slot:default>
            <tbody>
              <tr>
                <template v-for="(ele, i) in uniformsData">
                  <td v-bind:key="i">
                    <span class="ms-1 me-1">{{ ele.type || '-' }}</span>
                  </td>
                </template>
              </tr>
              <tr>
                <template v-for="(ele, i) in uniformsData">
                  <td v-bind:key="i">
                    <span class="ms-1 me-1">{{ ele.size || '-' }}</span>
                  </td>
                </template>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <div class="point" v-if="createEnquiry">
      <v-row>
        <v-col cols="12" sm="2">
          <span class="body-2 font-weight-medium ml-1"> Point Of Contact </span>
          <span class="error--text ml-1">*</span>
          <div class="d-flex">
            <v-checkbox
              v-model="value.fatherSelect"
              label="Father/Guardian"
              color="primary"
              value="father"
              hide-details
            ></v-checkbox>
            <v-checkbox
              class="ml-2"
              v-model="value.motherSelect"
              label="Mother"
              color="primary"
              value="mother"
              hide-details
            ></v-checkbox>
          </div>
        </v-col>
      </v-row>
    </div>

    <!--Select All Size Modal Start -->
    <v-dialog
      persistent
      v-model="selectAllModal"
      :active="selectAllModal"
      :on-cancel="
        () => {
          selectAllModal = false
        }
      "
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <uniformApplication
        ref="uniformApplicationRef"
        :key="refreshUniform"
        :enquiryDetails="value"
        v-on:closemodal="selectAllModal = false"
        v-on:uniformupdate="uniformsData = $event"
      ></uniformApplication>
    </v-dialog>
    <!--Select All Size Modal End -->
  </v-card-component>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import uniformApplication from '@/components/StudentUniforms/uniformApplication'
import constants from '@/utils/constants'
import _ from 'lodash'
// import { mapGetters } from 'vuex'
export default {
  name: 'StudentElement',
  props: {
    isUniformSelection: {
      default: false,
      type: Boolean
    },
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    },
    subType: {
      default: () => {}
    }
  },
  components: {
    VCardComponent,
    CustomDatePicker,
    uniformApplication
  },
  data: function () {
    return {
      studType: 'NewAdmission',
      isApplication: false,
      isEnquiry: false,
      isReadonly: false,
      isDisabled: false,
      cardTitle: '',
      cardIcon: '',
      isLoading: false,
      maxToDate: moment().format('YYYY-MM-DD'),
      selectAllModal: false,
      refreshUniform: 0,
      uniforms: {},
      apparelTypes: [],
      allKeys: null,
      uniformsData: [],
      fatherSelect: '',
      motherSelect: '',
      createEnquiry: false
    }
  },
  mounted: async function () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
    console.log('Previous Uniform Selection Check...')
    if (this.value?.id && this.value?.academicYearID && this.value?.gender) {
      this.getStudentUniforms()
    }
  },

  created () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
    if (this.formType === 'application') {
      this.isApplication = true
    } else if (this.formType === 'enquiry') {
      this.isEnquiry = true
      this.createEnquiry = true
    }
    if (this.formType === 'edit_registration') {
      this.isEnquiry = true
    }
    if (this.formType !== 'admission') {
      this.cardTitle = 'Student Details'
      this.cardIcon = 'mdi-human-child'
    }
  },
  methods: {
    getStudentUniforms: async function () {
      try {
        let uniforms = await http.get(
          `${constants.API_URL}/api/product/size-by-user-application`,
          {
            params: {
              enquiryID: this.value.id,
              academicYearID: this.value.academicYearID,
              gender: this.value.gender
            }
          }
        )
        console.log(uniforms.data, 'Student Element')
        this.uniforms = uniforms.data
        let apparelTypes = await http.get(
          `${constants.API_URL}/api/product/apparel-types-application`
        )
        this.apparelTypes = apparelTypes.data
        let apparelTypesGroup = _.groupBy(apparelTypes.data, 'type')
        let allKeys = Object.keys(apparelTypesGroup)
        this.allTypes = allKeys
        this.uniformsData = []
        let selectedProducts = []
        for (let key of allKeys) {
          for (let dress of this.uniforms[key]) {
            if (dress.selectedProductDetails) {
              // Previous Selection available
              this.uniformsData.push({
                type: `${key}-${dress.subType}`,
                size: dress.selectedProductDetails.productName,
                gender: dress.gender
              })
              selectedProducts.push(dress.selectedProductDetails)
            }
          }
        }
        console.log(this.uniformsData, 'uniformsData')
        // The below properties are defined so that application component can access these values
        Object.defineProperty(this.value, 'apparelTypes', {
          value: this.apparelTypes,
          enumerable: true,
          configurable: true
        })
        Object.defineProperty(this.value, 'uniforms', {
          value: this.uniforms,
          enumerable: true,
          configurable: true
        })
        let studentAppreals = []

        selectedProducts.map((prod) => {
          console.log(`${prod.type}-${prod.subType}`)
          studentAppreals.push({
            enquiryID: this.value.id,
            classID: this.value.classID,
            productID: prod.productID,
            apparelTypeID: prod.productTypeID,
            size: prod.size,
            quantity: prod.quantity
          })
        })
        console.log('Past Selection of Uniforms appended')
        Object.defineProperty(this.value, 'studentAppreals', {
          value: studentAppreals,
          enumerable: true,
          configurable: true
        })
        // this.$refs.uniformApplicationRef.getStudentUniforms()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.messagec
        this.errMsg(errorMessage)
      }
    },
    genderChangeHandler () {
      if (this.isUniformSelection) {
        this.refreshUniform++
        if (this.uniformsData.length > 0) {
          let prevGender = this.uniformsData[0]?.gender.toLowerCase()
          let currentGender = this.value?.gender.toLowerCase()
          if (prevGender !== currentGender && prevGender) {
            let that = this
            this.$buefy.dialog.confirm({
              title: 'Alert',
              message: `Are you sure do you want to change the Gender for this student ?
            Further there will be no change in the gender after submitting this Admission form.`,
              type: 'is-danger',
              hasIcon: true,
              cancelText: 'No',
              confirmText: 'Yes',
              canCancel: [false, 'button', false],
              onCancel: () => {
                this.value.gender =
                  this.value?.gender === 'Male' ? 'Female' : 'Male'
              },
              onConfirm: () => {
                that.getStudentUniforms()
              }
            })
          }
        }
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
